/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { Button, ButtonGroup } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import StripeCheckout from 'react-stripe-checkout'

import config from '../../../config'

/** Stripe publishable key */
const STRIPE_PUBLISHABLE_KEY = config.STRIPE_PUBLIC_KEY

const { STRIPE_V2 } = config

const useStyles = makeStyles(() => ({
  activeStep: {
    color: '#27A9E0 !important',
  },
  icon: {
    color: 'red !important',
  },
  fixedHeight: {
    height: 240,
  },
}))

const MemberShip: FC<any> = props => {
  const classes = useStyles()
  const { subscribeToProductPlan, billingTerms, setBillingTerms } = props

  return (
    <div style={{ display: 'contents' }}>
      <div style={{ textAlign: 'center', height: '6em' }}>
        <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
          <Button
            style={{ color: '#27a9e0' }}
            variant={billingTerms === 'Monthly' ? 'outlined' : undefined}
            onClick={(): void => {
              setBillingTerms('Monthly')
            }}
          >
            Monthly
          </Button>
          <Button
            style={{ color: '#27a9e0' }}
            variant={billingTerms === '6 Month' ? 'outlined' : undefined}
            onClick={(): void => {
              setBillingTerms('6 Month')
            }}
          >
            6 Month
          </Button>
          <Button
            style={{ color: '#27a9e0' }}
            variant={billingTerms === 'Yearly' ? 'outlined' : undefined}
            onClick={(): void => {
              setBillingTerms('Yearly')
            }}
          >
            Yearly
          </Button>
        </ButtonGroup>
      </div>
      <div className="row" />
      <div className="snip1214 row" style={{ display: 'contents' }}>
        {STRIPE_V2[billingTerms].map(column => (
          <div className={`plan${column.primaryHeader === 'Pro' ? ' featured' : ''}`}>
            <h3 className="plan-title">{column.primaryHeader}</h3>
            <div className="plan-cost">
              <span className="plan-price">{`$${column.price}`}</span>
              <span className="plan-type">/ Month</span>
              <p>{column.stripeDescription}</p>
            </div>
            <ul className="plan-features">
              {column.primaryHeader === 'Lite' ? (
                <li style={{ opacity: '0.5' }}>
                  <i className="ion-close"> </i>
                  {column.importedLeads}
                </li>
              ) : (
                <li>
                  <i className="ion-checkmark"> </i>
                  <b>{column.importedLeads}</b>
                </li>
              )}
              <li>
                <i className="ion-checkmark"> </i>
                <b>{column.templates}</b>
                pre-built, fully customizable missions
              </li>
              <li>
                <i className="ion-checkmark"> </i>
                No sending cap
              </li>
              <li>
                <i className="ion-checkmark"> </i>
                <b>{column.onboarding}</b>
                Onboading
              </li>
              {column.primaryHeader === 'Lite' ? (
                <li style={{ opacity: '0.5' }}>
                  <i className="ion-close"> </i>
                  {column.templateAssist}
                </li>
              ) : (
                <li>
                  <i className="ion-checkmark"> </i>
                  <b>{column.templateAssist}</b>
                </li>
              )}
              <li>
                <i className="ion-checkmark"> </i>
                Access to
                <b>{column.wingmanAccess}</b>
              </li>
            </ul>
            <div className="plan-select">
              <StripeCheckout
                name="MaverickApp"
                description={`Prospect Recon ${column.primaryHeader}`}
                token={(token): Promise<void> => subscribeToProductPlan(token, column.id)}
                billingAddress
                zipCode
                panelLabel="Subscribe"
                stripeKey={STRIPE_PUBLISHABLE_KEY}
              >
                {/* <a href="foo.com">Select Plan</a> */}
                <Button className={classes[column.buttonVariant]}>Select Plan</Button>
              </StripeCheckout>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MemberShip
